import { OccasionsEnum } from './bundles.types';

export enum SubmissionType {
  GROUP = 'GROUP',
  BUNDLE = 'BUNDLE',
}

export enum SubmissionSubType {
  BUNDLE_SETTING_CHANGE = 'BUNDLE_SETTING_CHANGE',
  DEACTIVATE_BUNDLE = 'DEACTIVATE_BUNDLE',
  NEW_BUNDLE_GROUP = 'NEW_BUNDLE_GROUP',
  EDIT_BUNDLE_GROUP = 'EDIT_BUNDLE_GROUP',
}

export enum SubmissionStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export enum SubmissionStatusLabels {
  PENDING = 'Pending',
  COMPLETED = 'Completed',
}

export enum SubmissionSubTypeLabels {
  BUNDLE_SETTING_CHANGE = 'Bundle Setting Change',
  DEACTIVATE_BUNDLE = 'Deactivate Bundle',
  NEW_BUNDLE_GROUP = 'New Store Group',
  EDIT_BUNDLE_GROUP = 'Edit Store Group',
}

export interface AdminSubmissionSummary {
  pendingCount: number;
  completedCount: number;
}

export interface FzSubmissionSummary {
  pendingBundleSettingCount: number;
  pendingDeactivateCount: number;
  pendingNewGroupCount: number;
  pendingEditGroupCount: number;
  completedBundleSettingCount: number;
  completedDeactivateCount: number;
  completedNewGroupCount: number;
  completedEditGroupCount: number;
}

export interface Changes {
  groupName: string;
  storeNo: string;
  oldPrice: number | null;
  newPrice: number | null;
  oldRedeemableOnline: boolean | null;
  newRedeemableOnline: boolean;
  oldVisibleOnline: boolean | null;
  newVisibleOnline: boolean;
  oldGroupName: string;
  newGroupName: string;
}

export interface Submission {
  id: string;
  code: string;
  orgId: string;
  bundleId: string;
  name: string;
  internalName: string;
  newGroupName: string;
  changes: Changes[] | undefined;
  type: SubmissionType;
  recommendedPrices: [];
  subType: SubmissionSubType;
  status: SubmissionStatus;
  occasions: OccasionsEnum[];
  bundleGroupsAffected: number;
  completedBy: string;
  completedDate: string;
  createdBy: string;
  createdDate: string;
}

export interface AdminSubmission {
  id: string;
  orgId: string;
  storesAffected: string[];
  lastChangeDate: string;
  completedDate: string;
  status: SubmissionStatus;
  nationalProgramName: string;
  nationalProgramType: string;
  nationalProgramId: string;
  submissionId: string;
  storesAffectedCount: number;
  fzCode: string;
}
